<template>
  <div class="ts-bg-white">
    <section>
      <div
        class="ts-py-24 ts-bg-no-repeat ts-bg-cover"
        :style="{
        'background-image':
          'url(' + require('@/assets/front/images/inner-page-bg.jpg') + ')'
      }"
      >
        <div class="ts-container ts-mx-auto ts-px-4">
          <h2 
             :class="$root.$i18n.locale == 'kh' ? 'ts-font-koulen ts-font-medium' : 'ts-font-heading-font'"
            class="ts-text-4xl sm:ts-text-6xl"
          >{{ $t('menu.privacyPolicy') }}</h2>
          <ts-breadcrumb
            :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman' : 'ts-font-robot'"
            class="ts-text-base"
            :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('menu.privacyPolicy'),
            active: true
          }
        ]"
          />
        </div>
      </div>
    </section>
    <section class="ts-py-12 lg:ts-py-32">
			<div class="ts-container ts-mx-auto ts-px-4">
				<a-skeleton :active="active" :loading="active" width="60px" :paragraph="{ rows: 15 }" />
				<div
					v-if="!active"
          :class="$root.$i18n.locale == 'kh' ? 'ts-font-hanuman ts-text-base' : 'ts-font-robot'"
					class="ts-text-base ts-font-robot ts-leading-7"
					v-html="resource.contents"
				>
				</div>
			</div>
    </section>
  </div>
</template>
<script>
export default {
	name: 'policyAndPrivacy',
	data(){
		return {
			resource: {},
			active: false,
		}
	},
	created(){
		this.fetchData()
	},
	methods: {
    async fetchData() {
      this.active = true
      await this.$store
        .dispatch('front/contentManagement/fetch', {
          filter: {
            content_type_id: 4
          }
        })
        .then(response => {
          this.resource = response.data
          this.active = false
        })
    }
  }
}
</script>